
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import ModalRefuse from '@/components/common/ModalRefuse.vue';
import Customer, { customerInitValue } from '@/types/customer/Customer';
import formatDate from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';
import Header from '@/types/app/header';
import CustomerHeaderInterest from '@/components/headers/customer-interest';
import CustomerHeaderRefused from '@/components/headers/customer-refused';
import ModalCreateInterest from '@/views/interests/create.vue';
import ModalImportInterest from '@/views/interests/import.vue';
import ModalRefused from '@/components/common/ModalRefused.vue';
import ModalCostumerRefused from '@/components/common/CostumerRefused.vue';
import ModalInterest from '@/components/common/ModalInterest.vue';
import moment from 'moment';
import ErrorService from '@/services/erroService';

const namespace = 'customer';
@Component({
  components: {
    modal: ModalRefuse,
    createInterest: ModalCreateInterest,
    importInterest: ModalImportInterest,
    refused: ModalRefused,
    undoRefused: ModalCostumerRefused,
    interest: ModalInterest,
  },
  methods: {
    formatDate,
  },
})
export default class Interests extends Vue {

  @Getter('getPendings', { namespace }) pendings!: Customer[];
  @Getter('getRefuseds', { namespace }) refuseds!: Customer[];
  @Getter('getLoading', { namespace }) loading!: boolean;
  @Action('setLoading', { namespace }) setLoading!: any;
  @Action('setCustomers', { namespace }) setCustomers!: any;
  @Action('removeCustomers', { namespace: 'customer' }) removeCustomers!: any;
  @Action('setCustomer', { namespace }) setCustomer!: any;
  @Action('setModalInterestState', { namespace }) setModalInterestState!: any;
  @Action('setModalRefusedState', { namespace }) setModalRefusedState!: any;
  @Action('setModalCreateInterestState', { namespace })
  setModalCreateInterestState!: any;
  @Action('setModalImportInterestState', { namespace: 'customer' })
  setModalImportInterestState!: any;
  @Getter('getModalCreateInterestState', { namespace })
  modalCreateInterestState!: boolean;
  @Getter('getModalImportInterestState', { namespace: 'customer' })
  modalImportInterestState!: boolean;

  private endpoint = new Endpoint();
  headersInterest: Array<Header> = CustomerHeaderInterest.header;
  headersRefused: Array<Header> = CustomerHeaderRefused.header;
  height = '';

  selectedInterest: any[] = [];
  selectedRefusedInterest: any[] = [];

  mounted() {
    this.getClientWidth();

    this.getCustomers();

    window.addEventListener('resize', this.getClientWidth);
  }

  get hasSelectedInterest() {
    return this.selectedInterest.length > 0;
  }

  get hasSelectToDelete() {
    return this.selectedInterest.length > 0 || this.selectedRefusedInterest.length > 0;
  }

  approvedAll(): void {
    this.setLoading(true);
    const roles = ["customer"];
    const users = this.selectedInterest.map(i =>
      ({ name: i.fullName, email: i.email, id: i.id, roles, classification: i.classification })
    );
    this.$http
      .post(this.endpoint.createListUser, users).then((resp: any) => {
        const data = (resp.data as any[]).map((r) => ({ customerId: r.id, userId: r.id, token: r.token, password: r.password }));

        this.$http
          .put(this.endpoint.acceptListCustomer, { requests: data }).then((resp: any) => {
            this.getCustomers();
            this.setLoading(false);
          });
      })
      .catch(error => {
        ErrorService.onError({ status: -1, message: 'Interest:ApprovedAll', error });
        this.setLoading(false);
      });
  }

  deletedAll(): void {

    this.$confirm('Do you really want to delete these interests?').then((res) => {
      if (res) {
        const url = `${this.endpoint.customers}`;
        const usersIdDisable = [...this.selectedInterest.map(x => x.id), ...this.selectedRefusedInterest.map(x => x.id)];
        this.setLoading(true);
        this.$http
          .delete(`${url}`, { data: { usersIdDisable } }).then((res: any) => {

            this.removeCustomers(usersIdDisable);
            this.selectedInterest = [];
            this.selectedRefusedInterest = [];
            this.setLoading(false);

          }).catch((error) => {
            this.setLoading(false);
            ErrorService.onError({ status: -1, message: 'Interest:DeletedAll', error });
          });
      }



    });
  }

  getClientWidth(): void {
    document.documentElement.clientWidth <= 599
      ? (this.height = '70vh')
      : (this.height = '35vh');
  }

  @Watch('modalImportInterestState')
  public fireOnCloseImportInterestModal() {
    if (!this.modalImportInterestState) {
      this.getCustomers();
    }
  }
  @Watch('modalCreateInterestState')
  public getCustomers(): void {
    if (!this.modalCreateInterestState) {
      this.setLoading(true);
      this.$http
        .get(`${this.endpoint.customers}`)
        .then((resp) => {
          this.setCustomers([]);
          this.setCustomers(resp.data);
          this.setLoading(false);
        })
        .catch((error) => {
          ErrorService.onError({ status: -1, message: 'Interest:getCustomers', error });
          this.setLoading(false);
        });
    }
  }

  setModalInterest(item: object): void {
    this.setCustomer(item);
    this.setModalCreateInterestState(true);
  }

  setModalRefused(item: object): void {
    this.setCustomer(item);
    this.setModalRefusedState(true);
  }

  showCreateModalInterests() {
    this.setCustomer(customerInitValue);
    this.setModalCreateInterestState(true);
  }

  showImportModalInterests() {
    this.setCustomer(customerInitValue);
    this.setModalImportInterestState(true);
  }
}
